export default "__VITE_ASSET__BKyqs4pf__"